import {ImageMasonryWall, useFetchEntries} from 'Event/ImageWaterfall'
import {PageDescription, PageTitle} from 'Event/template/NiftyFifty/Page'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'
import React from 'react'
import TextContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import {useAttendeeVariables} from 'Event'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'
import {useToggle} from 'lib/toggle'
import NiftyFiftyImageWaterfallConfig from 'Event/template/NiftyFifty/ImageWaterfall/ImageWaterfallConfig'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import Scripts, {IMAGE_WATERFALL} from 'Event/Scripts'

export default function NiftyFiftyImageWaterfall() {
  const {loading, entries} = useFetchEntries()
  const template = useNiftyFiftyTemplate()
  const {imageWaterfall: pageSettings} = template
  const v = useAttendeeVariables()
  const {flag: configVisible, toggle: toggleConfig} = useToggle()

  if (loading) {
    return <FullPageLoader />
  }

  return (
    <>
      <Scripts page={IMAGE_WATERFALL} />
      <EditModeOnly>
        <NiftyFiftyImageWaterfallConfig
          showing={configVisible}
          onClose={toggleConfig}
        />
      </EditModeOnly>
      <Editable onEdit={toggleConfig}>
        <PageTitle
          pageTitleColor={template.pageTitleColor}
          textColor={template.textColor}
        >
          {v(pageSettings.title)}
        </PageTitle>
      </Editable>
      <PageDescription color={template.textColor}>
        <TextContent>{v(pageSettings?.description)}</TextContent>
      </PageDescription>
      <ImageMasonryWall entries={entries} />
    </>
  )
}
